// Comprehensive list of sovereign countries + dependent territories with
// their ISO-3166 alpha-2 code, international dial code, flag emoji and
// display name. Used by the searchable Country selector AND the searchable
// dial-code selector in the Live Quran Classes lead form.
//
// Codes follow the ITU-T E.164 assignments; where multiple territories share
// a North-American dial code (+1) we include the canonical NANP entry plus
// distinct entries for territories whose users typically search by their
// own name (e.g. Canada, Puerto Rico, Bermuda).
export const COUNTRIES = [
  { name: "Afghanistan", iso: "AF", dial: "+93",  flag: "🇦🇫" },
  { name: "Albania",     iso: "AL", dial: "+355", flag: "🇦🇱" },
  { name: "Algeria",     iso: "DZ", dial: "+213", flag: "🇩🇿" },
  { name: "Andorra",     iso: "AD", dial: "+376", flag: "🇦🇩" },
  { name: "Angola",      iso: "AO", dial: "+244", flag: "🇦🇴" },
  { name: "Argentina",   iso: "AR", dial: "+54",  flag: "🇦🇷" },
  { name: "Armenia",     iso: "AM", dial: "+374", flag: "🇦🇲" },
  { name: "Australia",   iso: "AU", dial: "+61",  flag: "🇦🇺" },
  { name: "Austria",     iso: "AT", dial: "+43",  flag: "🇦🇹" },
  { name: "Azerbaijan",  iso: "AZ", dial: "+994", flag: "🇦🇿" },
  { name: "Bahamas",     iso: "BS", dial: "+1242", flag: "🇧🇸" },
  { name: "Bahrain",     iso: "BH", dial: "+973", flag: "🇧🇭" },
  { name: "Bangladesh",  iso: "BD", dial: "+880", flag: "🇧🇩" },
  { name: "Belarus",     iso: "BY", dial: "+375", flag: "🇧🇾" },
  { name: "Belgium",     iso: "BE", dial: "+32",  flag: "🇧🇪" },
  { name: "Belize",      iso: "BZ", dial: "+501", flag: "🇧🇿" },
  { name: "Benin",       iso: "BJ", dial: "+229", flag: "🇧🇯" },
  { name: "Bermuda",     iso: "BM", dial: "+1441", flag: "🇧🇲" },
  { name: "Bhutan",      iso: "BT", dial: "+975", flag: "🇧🇹" },
  { name: "Bolivia",     iso: "BO", dial: "+591", flag: "🇧🇴" },
  { name: "Bosnia and Herzegovina", iso: "BA", dial: "+387", flag: "🇧🇦" },
  { name: "Botswana",    iso: "BW", dial: "+267", flag: "🇧🇼" },
  { name: "Brazil",      iso: "BR", dial: "+55",  flag: "🇧🇷" },
  { name: "Brunei",      iso: "BN", dial: "+673", flag: "🇧🇳" },
  { name: "Bulgaria",    iso: "BG", dial: "+359", flag: "🇧🇬" },
  { name: "Burkina Faso",iso: "BF", dial: "+226", flag: "🇧🇫" },
  { name: "Burundi",     iso: "BI", dial: "+257", flag: "🇧🇮" },
  { name: "Cambodia",    iso: "KH", dial: "+855", flag: "🇰🇭" },
  { name: "Cameroon",    iso: "CM", dial: "+237", flag: "🇨🇲" },
  { name: "Canada",      iso: "CA", dial: "+1",   flag: "🇨🇦" },
  { name: "Cape Verde",  iso: "CV", dial: "+238", flag: "🇨🇻" },
  { name: "Cayman Islands", iso: "KY", dial: "+1345", flag: "🇰🇾" },
  { name: "Central African Republic", iso: "CF", dial: "+236", flag: "🇨🇫" },
  { name: "Chad",        iso: "TD", dial: "+235", flag: "🇹🇩" },
  { name: "Chile",       iso: "CL", dial: "+56",  flag: "🇨🇱" },
  { name: "China",       iso: "CN", dial: "+86",  flag: "🇨🇳" },
  { name: "Colombia",    iso: "CO", dial: "+57",  flag: "🇨🇴" },
  { name: "Comoros",     iso: "KM", dial: "+269", flag: "🇰🇲" },
  { name: "Congo (Brazzaville)", iso: "CG", dial: "+242", flag: "🇨🇬" },
  { name: "Congo (Kinshasa, DRC)", iso: "CD", dial: "+243", flag: "🇨🇩" },
  { name: "Costa Rica",  iso: "CR", dial: "+506", flag: "🇨🇷" },
  { name: "Côte d'Ivoire (Ivory Coast)", iso: "CI", dial: "+225", flag: "🇨🇮" },
  { name: "Croatia",     iso: "HR", dial: "+385", flag: "🇭🇷" },
  { name: "Cuba",        iso: "CU", dial: "+53",  flag: "🇨🇺" },
  { name: "Cyprus",      iso: "CY", dial: "+357", flag: "🇨🇾" },
  { name: "Czech Republic", iso: "CZ", dial: "+420", flag: "🇨🇿" },
  { name: "Denmark",     iso: "DK", dial: "+45",  flag: "🇩🇰" },
  { name: "Djibouti",    iso: "DJ", dial: "+253", flag: "🇩🇯" },
  { name: "Dominican Republic", iso: "DO", dial: "+1809", flag: "🇩🇴" },
  { name: "Ecuador",     iso: "EC", dial: "+593", flag: "🇪🇨" },
  { name: "Egypt",       iso: "EG", dial: "+20",  flag: "🇪🇬" },
  { name: "El Salvador", iso: "SV", dial: "+503", flag: "🇸🇻" },
  { name: "Eritrea",     iso: "ER", dial: "+291", flag: "🇪🇷" },
  { name: "Estonia",     iso: "EE", dial: "+372", flag: "🇪🇪" },
  { name: "Ethiopia",    iso: "ET", dial: "+251", flag: "🇪🇹" },
  { name: "Fiji",        iso: "FJ", dial: "+679", flag: "🇫🇯" },
  { name: "Finland",     iso: "FI", dial: "+358", flag: "🇫🇮" },
  { name: "France",      iso: "FR", dial: "+33",  flag: "🇫🇷" },
  { name: "Gabon",       iso: "GA", dial: "+241", flag: "🇬🇦" },
  { name: "Gambia",      iso: "GM", dial: "+220", flag: "🇬🇲" },
  { name: "Georgia",     iso: "GE", dial: "+995", flag: "🇬🇪" },
  { name: "Germany",     iso: "DE", dial: "+49",  flag: "🇩🇪" },
  { name: "Ghana",       iso: "GH", dial: "+233", flag: "🇬🇭" },
  { name: "Greece",      iso: "GR", dial: "+30",  flag: "🇬🇷" },
  { name: "Grenada",     iso: "GD", dial: "+1473", flag: "🇬🇩" },
  { name: "Guatemala",   iso: "GT", dial: "+502", flag: "🇬🇹" },
  { name: "Guinea",      iso: "GN", dial: "+224", flag: "🇬🇳" },
  { name: "Guyana",      iso: "GY", dial: "+592", flag: "🇬🇾" },
  { name: "Haiti",       iso: "HT", dial: "+509", flag: "🇭🇹" },
  { name: "Honduras",    iso: "HN", dial: "+504", flag: "🇭🇳" },
  { name: "Hong Kong",   iso: "HK", dial: "+852", flag: "🇭🇰" },
  { name: "Hungary",     iso: "HU", dial: "+36",  flag: "🇭🇺" },
  { name: "Iceland",     iso: "IS", dial: "+354", flag: "🇮🇸" },
  { name: "India",       iso: "IN", dial: "+91",  flag: "🇮🇳" },
  { name: "Indonesia",   iso: "ID", dial: "+62",  flag: "🇮🇩" },
  { name: "Iran",        iso: "IR", dial: "+98",  flag: "🇮🇷" },
  { name: "Iraq",        iso: "IQ", dial: "+964", flag: "🇮🇶" },
  { name: "Ireland",     iso: "IE", dial: "+353", flag: "🇮🇪" },
  { name: "Italy",       iso: "IT", dial: "+39",  flag: "🇮🇹" },
  { name: "Jamaica",     iso: "JM", dial: "+1876", flag: "🇯🇲" },
  { name: "Japan",       iso: "JP", dial: "+81",  flag: "🇯🇵" },
  { name: "Jordan",      iso: "JO", dial: "+962", flag: "🇯🇴" },
  { name: "Kazakhstan",  iso: "KZ", dial: "+7",   flag: "🇰🇿" },
  { name: "Kenya",       iso: "KE", dial: "+254", flag: "🇰🇪" },
  { name: "Kosovo",      iso: "XK", dial: "+383", flag: "🇽🇰" },
  { name: "Kuwait",      iso: "KW", dial: "+965", flag: "🇰🇼" },
  { name: "Kyrgyzstan",  iso: "KG", dial: "+996", flag: "🇰🇬" },
  { name: "Laos",        iso: "LA", dial: "+856", flag: "🇱🇦" },
  { name: "Latvia",      iso: "LV", dial: "+371", flag: "🇱🇻" },
  { name: "Lebanon",     iso: "LB", dial: "+961", flag: "🇱🇧" },
  { name: "Lesotho",     iso: "LS", dial: "+266", flag: "🇱🇸" },
  { name: "Liberia",     iso: "LR", dial: "+231", flag: "🇱🇷" },
  { name: "Libya",       iso: "LY", dial: "+218", flag: "🇱🇾" },
  { name: "Liechtenstein", iso: "LI", dial: "+423", flag: "🇱🇮" },
  { name: "Lithuania",   iso: "LT", dial: "+370", flag: "🇱🇹" },
  { name: "Luxembourg",  iso: "LU", dial: "+352", flag: "🇱🇺" },
  { name: "Macao",       iso: "MO", dial: "+853", flag: "🇲🇴" },
  { name: "Madagascar",  iso: "MG", dial: "+261", flag: "🇲🇬" },
  { name: "Malawi",      iso: "MW", dial: "+265", flag: "🇲🇼" },
  { name: "Malaysia",    iso: "MY", dial: "+60",  flag: "🇲🇾" },
  { name: "Maldives",    iso: "MV", dial: "+960", flag: "🇲🇻" },
  { name: "Mali",        iso: "ML", dial: "+223", flag: "🇲🇱" },
  { name: "Malta",       iso: "MT", dial: "+356", flag: "🇲🇹" },
  { name: "Mauritania",  iso: "MR", dial: "+222", flag: "🇲🇷" },
  { name: "Mauritius",   iso: "MU", dial: "+230", flag: "🇲🇺" },
  { name: "Mexico",      iso: "MX", dial: "+52",  flag: "🇲🇽" },
  { name: "Moldova",     iso: "MD", dial: "+373", flag: "🇲🇩" },
  { name: "Monaco",      iso: "MC", dial: "+377", flag: "🇲🇨" },
  { name: "Mongolia",    iso: "MN", dial: "+976", flag: "🇲🇳" },
  { name: "Montenegro",  iso: "ME", dial: "+382", flag: "🇲🇪" },
  { name: "Morocco",     iso: "MA", dial: "+212", flag: "🇲🇦" },
  { name: "Mozambique",  iso: "MZ", dial: "+258", flag: "🇲🇿" },
  { name: "Myanmar (Burma)", iso: "MM", dial: "+95", flag: "🇲🇲" },
  { name: "Namibia",     iso: "NA", dial: "+264", flag: "🇳🇦" },
  { name: "Nepal",       iso: "NP", dial: "+977", flag: "🇳🇵" },
  { name: "Netherlands", iso: "NL", dial: "+31",  flag: "🇳🇱" },
  { name: "New Zealand", iso: "NZ", dial: "+64",  flag: "🇳🇿" },
  { name: "Nicaragua",   iso: "NI", dial: "+505", flag: "🇳🇮" },
  { name: "Niger",       iso: "NE", dial: "+227", flag: "🇳🇪" },
  { name: "Nigeria",     iso: "NG", dial: "+234", flag: "🇳🇬" },
  { name: "North Korea", iso: "KP", dial: "+850", flag: "🇰🇵" },
  { name: "North Macedonia", iso: "MK", dial: "+389", flag: "🇲🇰" },
  { name: "Norway",      iso: "NO", dial: "+47",  flag: "🇳🇴" },
  { name: "Oman",        iso: "OM", dial: "+968", flag: "🇴🇲" },
  { name: "Pakistan",    iso: "PK", dial: "+92",  flag: "🇵🇰" },
  { name: "Palestine",   iso: "PS", dial: "+970", flag: "🇵🇸" },
  { name: "Panama",      iso: "PA", dial: "+507", flag: "🇵🇦" },
  { name: "Papua New Guinea", iso: "PG", dial: "+675", flag: "🇵🇬" },
  { name: "Paraguay",    iso: "PY", dial: "+595", flag: "🇵🇾" },
  { name: "Peru",        iso: "PE", dial: "+51",  flag: "🇵🇪" },
  { name: "Philippines", iso: "PH", dial: "+63",  flag: "🇵🇭" },
  { name: "Poland",      iso: "PL", dial: "+48",  flag: "🇵🇱" },
  { name: "Portugal",    iso: "PT", dial: "+351", flag: "🇵🇹" },
  { name: "Puerto Rico", iso: "PR", dial: "+1787", flag: "🇵🇷" },
  { name: "Qatar",       iso: "QA", dial: "+974", flag: "🇶🇦" },
  { name: "Romania",     iso: "RO", dial: "+40",  flag: "🇷🇴" },
  { name: "Russia",      iso: "RU", dial: "+7",   flag: "🇷🇺" },
  { name: "Rwanda",      iso: "RW", dial: "+250", flag: "🇷🇼" },
  { name: "Saudi Arabia",iso: "SA", dial: "+966", flag: "🇸🇦" },
  { name: "Senegal",     iso: "SN", dial: "+221", flag: "🇸🇳" },
  { name: "Serbia",      iso: "RS", dial: "+381", flag: "🇷🇸" },
  { name: "Sierra Leone",iso: "SL", dial: "+232", flag: "🇸🇱" },
  { name: "Singapore",   iso: "SG", dial: "+65",  flag: "🇸🇬" },
  { name: "Slovakia",    iso: "SK", dial: "+421", flag: "🇸🇰" },
  { name: "Slovenia",    iso: "SI", dial: "+386", flag: "🇸🇮" },
  { name: "Somalia",     iso: "SO", dial: "+252", flag: "🇸🇴" },
  { name: "South Africa",iso: "ZA", dial: "+27",  flag: "🇿🇦" },
  { name: "South Korea", iso: "KR", dial: "+82",  flag: "🇰🇷" },
  { name: "South Sudan", iso: "SS", dial: "+211", flag: "🇸🇸" },
  { name: "Spain",       iso: "ES", dial: "+34",  flag: "🇪🇸" },
  { name: "Sri Lanka",   iso: "LK", dial: "+94",  flag: "🇱🇰" },
  { name: "Sudan",       iso: "SD", dial: "+249", flag: "🇸🇩" },
  { name: "Suriname",    iso: "SR", dial: "+597", flag: "🇸🇷" },
  { name: "Sweden",      iso: "SE", dial: "+46",  flag: "🇸🇪" },
  { name: "Switzerland", iso: "CH", dial: "+41",  flag: "🇨🇭" },
  { name: "Syria",       iso: "SY", dial: "+963", flag: "🇸🇾" },
  { name: "Taiwan",      iso: "TW", dial: "+886", flag: "🇹🇼" },
  { name: "Tajikistan",  iso: "TJ", dial: "+992", flag: "🇹🇯" },
  { name: "Tanzania",    iso: "TZ", dial: "+255", flag: "🇹🇿" },
  { name: "Thailand",    iso: "TH", dial: "+66",  flag: "🇹🇭" },
  { name: "Togo",        iso: "TG", dial: "+228", flag: "🇹🇬" },
  { name: "Trinidad and Tobago", iso: "TT", dial: "+1868", flag: "🇹🇹" },
  { name: "Tunisia",     iso: "TN", dial: "+216", flag: "🇹🇳" },
  { name: "Türkiye (Turkey)", iso: "TR", dial: "+90", flag: "🇹🇷" },
  { name: "Turkmenistan",iso: "TM", dial: "+993", flag: "🇹🇲" },
  { name: "Uganda",      iso: "UG", dial: "+256", flag: "🇺🇬" },
  { name: "Ukraine",     iso: "UA", dial: "+380", flag: "🇺🇦" },
  { name: "United Arab Emirates", iso: "AE", dial: "+971", flag: "🇦🇪" },
  { name: "United Kingdom", iso: "GB", dial: "+44", flag: "🇬🇧" },
  { name: "United States", iso: "US", dial: "+1", flag: "🇺🇸" },
  { name: "Uruguay",     iso: "UY", dial: "+598", flag: "🇺🇾" },
  { name: "Uzbekistan",  iso: "UZ", dial: "+998", flag: "🇺🇿" },
  { name: "Vatican City",iso: "VA", dial: "+379", flag: "🇻🇦" },
  { name: "Venezuela",   iso: "VE", dial: "+58",  flag: "🇻🇪" },
  { name: "Vietnam",     iso: "VN", dial: "+84",  flag: "🇻🇳" },
  { name: "Yemen",       iso: "YE", dial: "+967", flag: "🇾🇪" },
  { name: "Zambia",      iso: "ZM", dial: "+260", flag: "🇿🇲" },
  { name: "Zimbabwe",    iso: "ZW", dial: "+263", flag: "🇿🇼" },
];

export const COUNTRY_BY_NAME = Object.fromEntries(COUNTRIES.map(c => [c.name, c]));
export const COUNTRY_BY_ISO  = Object.fromEntries(COUNTRIES.map(c => [c.iso, c]));
